<template>
  <div
    class="paginator"
    :key="componentKey"
  >
    <div class="categorycont">
      <div
        class="category"
        v-bind:class="{ current2: pageNumber === 0 || pageNumber === 1 }"
        @click="changeCat(0)"
      >
        Üzlet
      </div>
      <div
        class="category"
        v-bind:class="{ current2: pageNumber === 2}"
        @click="changeCat(2)"
      >
        Média
      </div>
      <div
        class="category"
        v-bind:class="{ current2: pageNumber === 3}"
        @click="changeCat(3)"
      >
        Közélet
      </div>
      <div
        class="category"
        v-bind:class="{ current2: pageNumber === 4}"
        @click="changeCat(4)"
      >
        Kultúra
      </div>
      <div
        class="category"
        v-bind:class="{ current2: pageNumber === 5}"
        @click="changeCat(5)"
      >
        Forbes Arcok
      </div>
    </div>
    <div
      class="item"
      v-for="(person, index) in paginatedData"
      v-bind:key="index"
      v-bind:class="{ sponscont: person.ad }"
    >
      <div
        class="woman"
        v-bind:class="{ even: index % 2 === 0 }"
        v-if="person.nev"
      >
        <div
          class="picture"
          v-bind:class="{ even: index % 2 === 0 }"
        >
          <img
            src="../assets/img/box1.svg"
            class="box1"
          >
          <img
            src="../assets/img/box2.svg"
            class="box2"
          >
          <img
            class="facerounded"
            :alt="person.nev"
            :src="'./faces/'+person.picture+'.png'"
          >
        </div>
        <div class="details">
          <div
            class="name"
            v-html="person.nev"
          >
          </div>
          <div
            class="profession"
            v-html="person.profession"
          >
          </div>
          <div
            class="balance"
            v-if="person.merleg"
            v-html="person.merleg"
          >
          </div>
          <div
            class="employees"
            v-if="person.alkalmazottak"
            v-html="person.alkalmazottak"
          >
          </div>
          <div
            class="othern"
            v-if="person.egyeb"
            v-html="person.egyeb"
          >
          </div>
          <div
            class="text"
            v-html="person.about"
          >
          </div>
        </div>
      </div>
      <div
        class="sponsad"
        v-if="person.ad"
      >
        <img
          src="../assets/img/woman-ad-bg.svg"
          alt="Reklám"
          class="backwoman"
        >
        <a
          href="http://bit.ly/2JADw8V"
          target="_blank"
        >
          <img
            src="../assets/img/vodafone-nok-ad.jpg"
            alt="A Vodafone támogatásával"
            class="picad"
          >
        </a>
      </div>
    </div>
    <div class="btncont">
      <div
        class="btn prev"
        v-if="pageNumber != 0"
        @click="prevPage()"
      >
        <img src="../assets/img/arrow.svg">
        <span>Előző {{stepsize-1}}</span>
      </div>
      <div
        class="btn next"
        v-if="(pageNumber+1)*stepsize < length"
        @click="nextPage()"
      >
        <span>Következő {{stepsize-1}}</span>
        <img src="../assets/img/arrow.svg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paginator',
  data() {
    return {
      pageNumber: 0,
      length: this.listData.length,
      stepsize: this.size,
      boxcontainer: null,
      componentKey: 0,
    };
  },
  props: {
    listData: {
      type: Array,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 11,
    },
  },
  methods: {
    getboxes() {
      setTimeout(() => {
        this.boxcontainer = document.querySelectorAll('.woman');
      }, 300);
    },
    animateBoxes() {
      this.getboxes();
      window.addEventListener('scroll', () => {
        if (this.boxcontainer) {
          for (let index = 0; index < this.boxcontainer.length; index += 1) {
            const element = this.boxcontainer[index];
            /* if (this.isinViewport(element)) {
              // this.moveCalculator(element);
              element.querySelector('.picture .facerounded')
                .setAttribute('style', `transform: translateY(${0}px)`);
              element.querySelector('.box1')
                .setAttribute('style', `transform: translateY(${0}px)`);
              element.querySelector('.box2')
                .setAttribute('style', `transform: translateY(${0}px)`);
            } else {
              element.querySelector('.picture .facerounded')
                .setAttribute('style', `transform: translateY(${15}px)`);
              element.querySelector('.box1')
                .setAttribute('style', `transform: translateY(${-20}px)`);
              element.querySelector('.box2')
                .setAttribute('style', `transform: translateY(${-20}px)`);
            } */
            this.moveCalculator(element);
          }
        }
      });
      window.addEventListener('touchmove', () => {
        for (let index = 0; index < this.boxcontainer.length; index += 1) {
          const element = this.boxcontainer[index];
          this.moveCalculator(element);
        }
      });
    },
    /* isinViewport(element) {
      const bounding = element.getBoundingClientRect();
      return (
        bounding.top >= 0
        && bounding.left >= 0
        && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }, */
    moveCalculator(element) {
      // center of animated element
      const itemCenter = element.offsetTop + (element.offsetHeight / 2);
      // from where to listen scroll
      const scrollStart = window.pageYOffset + (window.innerHeight / 10);
      // till when to listen scroll
      const scrollEnd = window.pageYOffset + ((window.innerHeight / 10) * 9);
      // element is in center
      const scrollMid = scrollStart + ((scrollEnd - scrollStart) / 2);
      // scroll range
      const scrollRange = itemCenter - scrollMid;
      // distance
      const distance = 0.15;

      /* if (itemCenter < scrollMid) { // feljebb
        element.querySelector('.box1')
          .setAttribute('style', `transform: translateY(${distance * scrollRange}px)`);
        element.querySelector('.box2')
          .setAttribute('style', `transform: translateY(${distance * scrollRange * -1}px)`);
      }
      if (itemCenter > scrollMid) { // lejjebb
        element.querySelector('.box1')
          .setAttribute('style', `transform: translateY(${distance * scrollRange}px)`);
        element.querySelector('.box2')
          .setAttribute('style', `transform: translateY(${distance * scrollRange * -1}px)`);
      } */
      if (itemCenter <= scrollMid) {
        element.querySelector('.picture .facerounded').setAttribute('style', `transform: translateY(${distance * scrollRange}px)`);
        element.querySelector('.box1').setAttribute('style', `transform: translateY(${(distance * scrollRange) * -1}px)`);
        element.querySelector('.box2').setAttribute('style', `transform: translateY(${(distance * scrollRange) * -1}px)`);
      } if (itemCenter > scrollMid) {
        element.querySelector('.picture .facerounded').setAttribute('style', `transform: translateY(${distance * scrollRange}px)`);
        element.querySelector('.box1').setAttribute('style', `transform: translateY(${(distance * scrollRange) * -1}px)`);
        element.querySelector('.box2').setAttribute('style', `transform: translateY(${(distance * scrollRange) * -1}px)`);
      }
    },
    nextPage() {
      this.methodThatForcesUpdate();
      setTimeout(() => {
        this.pageNumber += 1;
        this.scrollTop(0);
        this.getboxes();
        this.sizeAd();
        this.urlUpdate(this.pageNumber);
        this.closeToggles();
      }, 100);
    },
    prevPage() {
      this.methodThatForcesUpdate();
      setTimeout(() => {
        this.pageNumber -= 1;
        this.scrollTop(0);
        this.getboxes();
        this.sizeAd();
        this.urlUpdate(this.pageNumber);
        this.closeToggles();
      }, 100);
    },
    scrollTop(pos) {
      // window.scrollTo(0, 0);
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: pos,
      });
    },
    sizeAd() {
      setTimeout(() => {
        const sponselement = document.querySelector('.sponsad .backwoman');
        if (sponselement) {
          sponselement.setAttribute('style', `width:${(document.body.clientWidth)}px`);
          window.addEventListener('resize', () => {
            sponselement.setAttribute('style', `width:${(document.body.clientWidth)}px`);
          });
        }
      }, 200);
    },
    changeCat(number) {
      this.methodThatForcesUpdate();
      setTimeout(() => {
        this.pageNumber = number;
        this.getboxes();
        this.sizeAd();
        this.urlUpdate(number);
        this.closeToggles();
        const list = document.querySelector('.list').offsetTop;
        this.scrollTop(list - 20);
      }, 10);
    },
    urlUpdate(pgNumber) {
      let urlText = '';
      if (pgNumber === 0 || pgNumber === 1) {
        urlText = 'uzlet';
      }
      if (pgNumber === 2) {
        urlText = 'media';
      }
      if (pgNumber === 3) {
        urlText = 'kozelet';
      }
      if (pgNumber === 4) {
        urlText = 'kultura';
      }
      if (pgNumber === 5) {
        urlText = 'forbes-arcok';
      }
      this.$router.push({ path: `${urlText}` });
      setTimeout(() => {
        this.detailsBtn();
      }, 200);
    },
    closeToggles() {
      const modszertancont = document.querySelector('.modszertan .expanded');
      if (modszertancont.classList.contains('show')) {
        document.querySelector('.mopener').click();
      }
      const descriptions = document.querySelectorAll('.details');
      for (let index = 0; index < descriptions.length; index += 1) {
        const element = descriptions[index];
        if (element.classList.contains('expanded')) {
          element.classList.remove('expanded');
        }
      }
    },
    detailsBtn() {
      const descriptions = document.querySelectorAll('.details');
      for (let index = 0; index < descriptions.length; index += 1) {
        const toggler = document.createElement('div');
        toggler.classList.add('moreBtn');
        const element = descriptions[index];
        if (element.clientHeight >= 300 && !element.querySelector('.moreBtn')) {
          element.setAttribute('style', 'height: 300px');
          element.appendChild(toggler);
          toggler.addEventListener('click', () => {
            element.classList.toggle('expanded');
          });
        }
      }
    },
    methodThatForcesUpdate() {
      this.componentKey += 1;
    },
    gotopage() {
      if (this.$parent.$parent.p) {
        this.pageNumber = this.$parent.$parent.p;
      }
    },
    selectCat(numberP) {
      const categories = document.querySelectorAll('.category');
      if (numberP === '0' || numberP === '1') {
        categories[0].classList.toggle('current');
      }
      if (numberP === '2') {
        categories[1].classList.toggle('current');
      }
      if (numberP === '3') {
        categories[2].classList.toggle('current');
      }
      if (numberP === '4') {
        categories[3].classList.toggle('current');
      }
      if (numberP === '5') {
        categories[4].classList.toggle('current');
      }
    },
  },
  watch: {
    pageNumber(newVal) {
      this.selectCat(newVal);
      /* this.$ga.page({
        title: `A Legbefolyásosabb Magyar Nők 2019. Page: ${newVal}`,
        page: '/extra/a-legbefolyasosabb-magyar-nok-2019/',
        location: window.location.href,
      }); */
    },
  },
  computed: {
    pageCount() {
      const l = this.listData.length;
      const s = this.size;
      return Math.floor(l / s);
    },
    paginatedData() {
      const start = this.pageNumber * this.size;
      const end = start + this.size;
      return this.listData
        .slice(start, end);
    },
  },
  mounted() {
    this.gotopage();
    this.animateBoxes();
    this.sizeAd();
    this.urlUpdate(this.pageNumber);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.facerounded {
  width: 240px;
  position: relative;
  z-index: 3;
}
.item {
  max-width: 850px;
  width: 100%;
  margin: 30px auto;
}
.item.sponscont {
  width: 100%;
  max-width: 100vw;
  margin: 5vw auto 18vw auto;
  position: relative;
  z-index: 3;
}
.woman {
  display: grid;
  display: -ms-grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  -ms-grid-columns: auto auto;
  -ms-grid-rows: auto;
  align-items: center;
  padding: 7% 0;
}
.woman.even .picture {
  grid-column: 1/2;
  -ms-grid-column: 1;
  grid-row: 1/2;
  -ms-grid-row: 1;
  text-align: right;
}
.woman.even .details {
  grid-column: 2/3;
  -ms-grid-column: 2;
  grid-row: 1/2;
  -ms-grid-row: 1;
  text-align: left;
  padding: 0 0 0 40px;
}
.woman .picture {
  grid-column: 2/3;
  -ms-grid-column: 2;
  grid-row: 1/2;
  -ms-grid-row: 1;
  width: 345px;
  position: relative;
  line-height: 0;
  align-self: start;
  padding-top: 15%;
}
.woman .details {
  grid-column: 1/2;
  -ms-grid-column: 1;
  padding: 0 40px 0 0;
  grid-row: 1/2;
  -ms-grid-row: 1;
  text-align: right;
  position: relative;
  z-index: 2;
  overflow: hidden;
}
.picture .facerounded {
  transform: translateY(24px);
}
.box1,
.box2 {
  position: absolute;
  width: 79%;
  transform: translateY(-24px);
}
.even .box1 {
  left: 0;
  top: 10%;
}
.even .box2 {
  left: 7%;
  top: -6%;
}
.box1 {
  left: initial;
  right: 0;
  top: 10%;
  z-index: 1;
}
.box2 {
  left: initial;
  right: 7%;
  top: -10%;
  z-index: 2;
}
.name {
  font-family: "Montserrat", sans-serif;
  font-size: 30px;
  font-weight: 700;
  margin-top: 10px;
}
.profession {
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-weight: 300;
  font-style: italic;
  margin: 5px 0 17px 0;
}
.balance,
.employees,
.othern {
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 500;
  font-style: italic;
  line-break: initial;
  color: #a34f4b;
  margin-bottom: 5px;
}
.text {
  font-size: 16px;
}
.sponsad {
  max-width: 850px;
  margin: 0 auto;
}
.sponsad .picad {
  margin: 0 auto;
  position: relative;
  display: block;
  width: 100%;
}
.sponsad .backwoman {
  position: absolute;
  left: -30px;
}
.btncont {
  display: flex;
  flex-wrap: nowrap;
  margin: 90px auto;
  justify-content: center;
}
.btn {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  width: fit-content;
  cursor: pointer;
  margin: 0 10px;
}
.btn span {
  padding-bottom: 5px;
}
.btn img {
  width: 20px;
  margin: 0 0 0 10px;
}
.btn.prev img {
  transform: rotate(180deg);
  margin: 0 10px 0 0;
}
.btn:hover span {
  border-bottom: 1px solid #000;
}
.categorycont {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 0 10px 0;
}
.category {
  cursor: pointer;
  margin: 0 10px 10px 10px;
  font-family: "Montserrat", sans-serif;
  padding-bottom: 4px;
  text-transform: uppercase;
}
.category:hover {
  border-bottom: 2px solid #1f1f1f;
  margin: 0 10px 8px 10px;
}
.category.current,
.category.current2 {
  border-bottom: 2px solid #1f1f1f;
  font-weight: 700;
}
.category.current:hover,
.category.current2:hover {
  margin: 0 10px 10px 10px;
}
.paginator div:nth-child(2) {
  overflow: hidden;
  margin-top: 0px;
}
.details.expanded {
  height: initial !important;
}
@media screen and (max-width: 1220px) {
  .item.sponscont {
    margin: 50px auto 50px auto;
  }
  .sponsad {
    height: 711px;
  }
  .sponsad .backwoman {
    right: -30px;
    left: initial;
    width: 1220px !important;
  }
}
@media screen and (max-width: 840px) {
  .sponsad {
    height: calc(54vw + 564px);
  }
  .sponsad .backwoman {
    bottom: 0;
  }
}
@media screen and (max-width: 767px) {
  .woman .picture {
    width: 245px;
  }
  .facerounded {
    width: 180px;
  }
  .woman.even .details {
    padding: 0 0 0 15px;
  }
  .woman .details {
    padding: 0 15px 0 0;
  }
}
@media screen and (max-width: 640px) {
  .woman .picture {
    width: 200px;
  }
  .facerounded {
    width: 150px;
  }
}
@media screen and (max-width: 520px) {
  .woman .picture {
    width: 150px;
  }
  .facerounded {
    width: 120px;
  }
}
@media screen and (max-width: 440px) {
  .woman {
    grid-template-columns: auto;
    grid-template-rows: auto auto;
    -ms-grid-columns: auto;
    -ms-grid-rows: auto auto;
    padding: 15% 0;
  }
  .woman .picture {
    width: 100%;
    grid-column: 1/2;
    -ms-grid-column: 1;
    justify-self: start;
    margin-bottom: 25px;
  }
  .woman.even .picture {
    justify-self: end;
  }
  .woman .details {
    grid-row: 2/3;
    -ms-grid-row: 2;
  }
  .woman.even .details {
    grid-column: 1/2;
    -ms-grid-column: 1;
    grid-row: 2/3;
    -ms-grid-row: 2;
  }
  .facerounded {
    width: 70%;
  }
  .item {
    margin: 60px auto;
  }
  .name {
    font-size: 25px;
  }
}
</style>
<style>
.woman .moreBtn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(100% - 40px);
  height: 70px;
  background-image: url("../assets/img/arrow-down-toggle.svg"),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 10%,
      rgba(255, 255, 255, 1) 100%
    );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff',
  endColorstr='#ffffff',GradientType=0 );
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 15px, cover;
}
.woman.even .moreBtn {
  right: 0;
  left: initial;
  width: 100%;
}
.woman .details.expanded .moreBtn {
  position: relative;
  height: 15px;
  background-image: url("../assets/img/arrow-up-toggle.svg"),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 10%,
      rgba(255, 255, 255, 1) 100%
    );
  width: 100%;
}
.woman.even .details.expanded .moreBtn {
  width: calc(100% - 40px);
}
.text p:last-child {
  margin-bottom: 0px;
  margin-block-end: 0px;
}
@media screen and (max-width: 767px) {
  .woman .moreBtn {
    width: calc(100% - 15px);
  }
}
</style>
